export const calculadorasDinamicasRoutes = (apiBase) => ({
  calculadorasDinamicas: `${apiBase}/calculadoras-dinamicas`,
  calculadorasDinamicasById: (id) => `${apiBase}/calculadoras-dinamicas/by-id?id=${id}`,
  calculadorasDinamicasDefinition: (id) =>
    `${apiBase}/calculadoras-dinamicas/definition?id=${id}`,
  calculadorasDinamicasEstado: `${apiBase}/calculadoras-dinamicas/estado`,
  calculadorasDinamicasFuentes: `${apiBase}/calculadoras-dinamicas/fuentes`,
  calculadorasDinamicasFuenteById: (id) =>
    `${apiBase}/calculadoras-dinamicas/fuentes/by-id?id=${id}`,
  calculadorasDinamicasPublicadas: (sexo, edad) =>
    `${apiBase}/calculadoras-dinamicas/publicadas?sexo=${sexo}&edad=${edad}`,
});
